import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ncoder/ui';
import { TestStatusItem } from '../../atoms/testing/TestStatusItem';

interface TestStatusPanelProps {
  testsPassed: number;
  testsFailed: number;
  successRate: string;
}

export const TestStatusPanel: React.FC<TestStatusPanelProps> = ({
  testsPassed,
  testsFailed,
  successRate,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Test Status</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <TestStatusItem label="Tests Passed" value={testsPassed} color="green" />
          <TestStatusItem label="Tests Failed" value={testsFailed} color="red" />
          <TestStatusItem label="Success Rate" value={successRate} color="default" />
        </div>
      </CardContent>
    </Card>
  );
};
